import request from '../request';
import { ccm19Enabled, detectExternalConsent } from '../lib/consent';

const externalConsent = ccm19Enabled() ? null : detectExternalConsent();

if (externalConsent !== null) {
  sessionStorage.setItem('cookiesAccepted', externalConsent === 'granted');
  sessionStorage.setItem('cookieMessageVisible', false);
}

let cookiesAccepted = sessionStorage.getItem('cookiesAccepted');

if (cookiesAccepted === 'true') {
  cookiesAccepted = true;
} else {
  cookiesAccepted = false;
}

let cookieMessageVisible = sessionStorage.getItem('cookieMessageVisible');

if (cookieMessageVisible === 'true') {
  cookieMessageVisible = true;
} else {
  cookieMessageVisible = false;
}

function disableTagManager() {
  const gtm = window.vue?.$gtm;
  if (gtm && typeof gtm.enable === 'function' && gtm.enabled()) {
    gtm.enable(false);
  }
}

export default {
  namespaced: true,
  state: {
    isVisible: cookieMessageVisible,
    disclaimer: '',
    cookiesAccepted,
  },
  mutations: {
    set(state, msg) {
      state.disclaimer = msg;
    },
    accept(state) {
      state.cookiesAccepted = true;
      sessionStorage.setItem('cookiesAccepted', true);
    },
    dontAccept(state) {
      state.cookiesAccepted = false;
      sessionStorage.setItem('cookiesAccepted', false);
    },
    setVisible(state, v) {
      state.isVisible = v;
      sessionStorage.setItem('cookieMessageVisible', v);
    },
  },
  actions: {
    get(context) {
      return new Promise((resolve, reject) => {
        const { app } = context.rootState;
        const url = `${app.API_URL}${context.rootState.language}/${app.endpoints.STATIC_CONTENT}`;
        const type = 'GET';
        request.make(
          {
            url,
            type,
          },
          (reqErr, res) => {
            if (res.status === 200 && typeof res.body.data.cookie_warning !== 'undefined') {
              context.commit('set', res.body.data.cookie_warning);
              resolve();
            }
            reject();
          }
        );
      });
    },
    accept(context) {
      context.commit('accept');
      context.commit('setVisible', false);
    },
    dontAccept(context) {
      context.commit('dontAccept');
      context.commit('setVisible', false);
      disableTagManager();
    },
    setVisible(context, v) {
      context.commit('setVisible', v);
    },
  },
};
